<script setup>
import VoixVideoControlsButtons from "./VoixVideoControlsButtons.vue";
defineProps({
  play: { type: Function, required: true },
  pause: { type: Function, required: true },
  paused: { type: Boolean, required: true },
  mute: { type: Function, required: true },
  unMute: { type: Function, required: true },
  muted: { type: Boolean, required: true },
  volume: { type: Number, required: true },
  setVolume: { type: Function, required: true },
  fullscreen: { type: Function, required: true },
  allowFullscreen: { type: Boolean, required: true },
  controlsPosition: { type: String, required: true }
});
</script>

<template>
  <div class="w-full h-full grid grid-row-3 gap-4 p-4">
    <!-- Top Row -->
    <div class="w-full h-full flex flex-row space-x-4">
      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'top left'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'top center'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'top right'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>
    </div>

    <!-- Middle Row -->
    <div class="w-full h-full flex flex-row space-x-4">
      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'middle left'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'middle center'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'middle right'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>
    </div>

    <!-- Bottom Row -->
    <div class="w-full h-full flex flex-row space-x-4">
      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'bottom left'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'bottom center'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'bottom right'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>
    </div>
  </div>
</template>
